import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b7d902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drop-down__menu" }
const _hoisted_2 = { class: "drop-down__user-name" }
const _hoisted_3 = { class: "drop-down__user-email" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Sair ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item = _resolveComponent("item")!
  const _component_Suggestion = _resolveComponent("Suggestion")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['drop-down__menu-box', { open: _ctx.isOpened }])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, _toDisplayString(_ctx.user.socialName || _ctx.user.name), 1),
      _createElementVNode("li", _hoisted_3, _toDisplayString(_ctx.user.email), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_item, {
          item: item,
          class: _normalizeClass({
          'disabled-menu-item': _ctx.isMaintenance && !item.isAlwaysEnabled
        })
        }, null, 8, ["item", "class"]))
      }), 256)),
      _createElementVNode("li", {
        class: "drop-down__logout",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, [
        _createElementVNode("img", {
          width: "20",
          height: "20",
          src: require(`../../../../assets/static/main-menu/logout.svg`),
          alt: "Ícone de logout"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ])
    ]),
    _createVNode(_component_Suggestion, {
      isOpen: _ctx.showConfirmation,
      onToggle: _ctx.closeSuggestionModal
    }, null, 8, ["isOpen", "onToggle"])
  ], 2))
}